import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const TempleGate = {
  id: '124',
  name: 'Temple Gate',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Temple_Gate',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Temple_Gate',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(4),
      [
        ProductionCost.asFlat(24).withCurrency(ProductionCurrency.INFANTRY_UNITS),
      ],
      ProductionDuration.asCallbackWithLevel(
        (level) => {
          return 17 * 60 * 60 - ((level - 1) * 15 * 60);
        }
      ),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.WONDER_HELP_ACTION),
    ),
  ]),
};

export default TempleGate;
